export const firebaseConfig = {
    apiKey: "AIzaSyCYYTjVL5lUJdzPBjXz4GqDh9wruG5ejVY",
    authDomain: "congreso-cicop-2023.firebaseapp.com",
    projectId: "congreso-cicop-2023",
    storageBucket: "congreso-cicop-2023.appspot.com",
    messagingSenderId: "8672798615",
    appId: "1:8672798615:web:51511db8d13cb75f55c6d2"
  };